import { Component, OnInit } from '@angular/core';

@Component( {
    selector: 'ridango-block-items-two',
    templateUrl: './block-items-two.component.html',
    styleUrls: [ './block-items-two.component.css' ]
} )
export class BlockItemsTwoComponent implements OnInit {
    constructor() { }
    ngOnInit () { }
}
